module.exports = __webpack_public_path__ + "media/images/clone-22c28d60de400fa90b91f794752620ce.svg";